import React from 'react';
import { Handle, Position } from 'reactflow';
import { FileText } from 'lucide-react';

const TextGenNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-purple-200 node-text-gen">
      <div className="flex items-center">
        <FileText className="w-4 h-4 text-purple-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-purple-800">Gemini Text Gen</div>
          <div className="text-sm text-gray-600">
            Grade {data.config?.gradeLevel || '4'} • {data.config?.language || 'English'}
          </div>
          <div className="text-xs text-purple-600">
            {data.config?.concept || 'Educational content generation'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500 border-2 border-white"
      />
    </div>
  );
};

export default TextGenNode;